var map = {
	"./chevron-left.svg": 646,
	"./chevron-right.svg": 647,
	"./facebook.svg": 648,
	"./instagram.svg": 649,
	"./loading.svg": 650,
	"./mastercard.svg": 651,
	"./menu.svg": 652,
	"./spinner.svg": 653,
	"./strava.svg": 654,
	"./trash.svg": 655,
	"./upload.svg": 656,
	"./visa.svg": 657,
	"./xlsx-file.svg": 658,
	"./youtube.svg": 659
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1258;



//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1258
// module chunks = 0